<template>
  <div class="about">
    <div class="aboutContent">
      <div class="logo">
        <img :src="logo" alt="" class="img">
        <div class="version">
          当前版本&nbsp;&nbsp;V1.0
        </div>
      </div>
      <div class="intro">
        <div class="info-item" v-for="(item, index) in list" :key="index">
          <div class="label">{{ item.label }}</div>
          <div class="value">{{ item.value }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      logo: require('../../assets/images/logo.png'),
      list: [
        { label: '联系方式', value: 'aiiai@caas.cn' },
        { label: '单位名称', value: '中国农业科学院农业信息研究所' },
        { label: '联系地址', value: '北京市海淀区中关村南大街12号' },
      ]
    }
  }
}
</script>
<style lang="stylus">
  .about {
    height: 100vh;
    background: #F1F1F1;
    .aboutContent {
      padding: 50px 30px 0 30px;
      .logo {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .img {
          width: 140px;
          height: 140px;
        }
        .version {
          color: #999999;
          font-size: 30px;
          margin-top: 20px;
          // font-weight: bold;
        }
      }
      .intro {
        margin-top: 50px;
        .info-item {
          padding: 35px 0;
          display: flex;
          justify-content: space-between;
          align-items: center;
          border-bottom: 1PX solid rgba(0, 0, 0, 0.1);
          .label {
            color: #333333;
            font-size: 30px;
            font-weight: 500;
          }
          .value {
            color: #333333;
            font-size: 26px;
            font-weight: 400;
          }
        }
      }
    }
  }
</style>